import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import CategorieCount from "./componentsHomepage/CategorieCount";
import Cards from "./home/Cards";
import Search from "./home/Search";
import CardsAdmin from "./home/CardsAdmin";
import CandidatRecent from "./home/CandidatRecent";
import SousCategorieCounter from "./componentsHomepage/SousCategorieCounter";
import RecentIdealProfil from "./home/RecentIdealProfil";
import Loader from "../Loader";
import CategorySearch from "./home/CategorySearch";
import CategoryRow from "./componentsHomepage/CategoryRow";

class Homepage extends Component {
    state = {
        categories: [],
        sousCategories: [],
        spin: true
    }

    componentDidMount() {
        Promise.all([this.getCategories(), this.getSousCategories()])
            .then(() => this.setState({ spin: false }))
            .catch(error => console.log(error));
    }

    getCategories = () => {
        return axios.get('categorie_cvs')
            .then(resp => {
                if (resp.status === 200) {
                    this.setState({ categories: resp.data });
                }
            });
    }

    getSousCategories = () => {
        return axios.get('sous_categories')
            .then(resp => {
                if (resp.status === 200) {
                    this.setState({ sousCategories: resp.data });
                }
            });
    }

    renderCategories = (data, CounterComponent, isSubCategory = false) => {
        const { user } = this.props;
        return data.map(item => (
            <CategoryRow
                key={item.id}
                item={item}
                CounterComponent={CounterComponent}
                isSubCategory={isSubCategory}
                user={user}
            />
        ));
    }

    render() {
        const { sousCategories, categories, spin } = this.state;
        const { user } = this.props;

        if (spin) {
            return <Loader />;
        }

        const cards = user.role === 'Administrateur' ? <CardsAdmin /> : <Cards usr={user} />;
        const idealProf = user.role === 'Administrateur' && (
            <div className="card">
                <div className="card-header">Je ne trouve pas mon profil idéal</div>
                <RecentIdealProfil use={user} />
            </div>
        );

        return (
            <>
                <div className="adminx-content">
                    <div className="adminx-main-content">
                        <div className="container-fluid">
                            <nav aria-label="breadcrumb" role="navigation">
                                <ol className="breadcrumb adminx-page-breadcrumb">
                                    <li className="breadcrumb-item"><a href="#">Accueil</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Tableau de bord</li>
                                </ol>
                            </nav>

                            <div className="pb-3">
                                <h1>Tableau de bord</h1>
                            </div>
                            {cards}
                            <Search ctg={categories} user={user} />
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <div className="card-header-title">List</div>
                                        </div>
                                        <div style={{ padding: 15 }}>
                                            <CategorySearch searchable={categories} />
                                        </div>
                                        <div className="card-body collapse show table-wrapper-scroll-y my-custom-scrollbar" id="card1">
                                            <table className="table table-actions table-striped table-hover mb-0 dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Categorie</th>
                                                        <th scope="col">Nombre de CV</th>
                                                        <th scope="col">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {this.renderCategories(categories, CategorieCount)}
                                                {this.renderCategories(sousCategories, SousCategorieCounter, true)}
                                                </tbody>
                                            </table>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card">
                                        <div className="card-header">Candidat récent</div>
                                        <CandidatRecent use={user} />
                                    </div>
                                    {/* {idealProf} */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Homepage;